import React from 'react';

import { chain } from '@lyearn/core/utils/immutable';
import { useTranslation } from '@lyearn/i18n';
import { Box, Stack, Typography } from '@lyearn/ui';

import { FrequencyComponentProps } from '../../../types';
import DateInput from '../../InputComponents/Date';
import TimeOfDay from '../../InputComponents/TimeOfDay';
import IntervalInput from './CustomInputComponents/IntervalInput';
import CustomFrequencyInput from './CustomFrequencyInput';

const CustomWeek: React.FC<FrequencyComponentProps> = React.memo((props) => {
  const { value, onChange, hideTimeSelection, disabled, allowedCustomFrequencies, size } = props;
  const { t } = useTranslation();

  const onDateInputChange: FrequencyComponentProps['onChange'] = React.useCallback(
    ({ dayOfMonth, MonthOfYear }) => {
      onChange(
        chain(value)
          .setIn(['custom', 'dayOfMonth'], dayOfMonth)
          .setIn(['custom', 'monthOfYear'], MonthOfYear)
          .value(),
      );
    },
    [onChange, value],
  );

  return (
    <Stack direction="col" gapY={16}>
      <Stack alignItems="center" justifyContent="start">
        <Box className="flex w-1/2 flex-row items-center space-s-8">
          <IntervalInput disabled={disabled} size={size} value={value} onChange={onChange} />
          <CustomFrequencyInput
            allowedCustomFrequencies={allowedCustomFrequencies}
            disabled={disabled}
            size={size}
            value={value}
            onChange={onChange}
          />
        </Box>
        <Box className="flex w-1/2 flex-row items-center">
          <Typography
            className="mx-12"
            variant={size === 'medium' ? 'body-short-02' : 'body-short-01'}>
            {t('Common:On')}
          </Typography>
          <DateInput
            className="flex flex-1"
            disabled={disabled}
            size={size}
            value={{
              ...value,
              MonthOfYear: value.custom?.monthOfYear,
              dayOfMonth: value.custom?.dayOfMonth,
            }}
            onChange={onDateInputChange}
          />
        </Box>
      </Stack>
      {hideTimeSelection ? null : (
        <TimeOfDay disabled={disabled} size={size} value={value} onChange={onChange} />
      )}
    </Stack>
  );
});

export default CustomWeek;
